import { css } from 'styled-components';

import { FontSize, FontType, FontWeight } from './Fonts';
import { MediaQuery } from './Styles';

const TypoHugeBolder = css`
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.HUGE};
  font-weight: ${FontWeight.BLACK};

  ${MediaQuery.S_AND_DOWN} {
    font-size: ${FontSize.XL};
  }
`;

const TypoXxxxxlBolder = css`
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.XXXXXL};
  font-weight: ${FontWeight.BLACK};

  ${MediaQuery.S_AND_DOWN} {
    font-size: ${FontSize.XXL};
  }
`;

const TypoXxxxlBolder = css`
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.XXXXL};
  font-weight: ${FontWeight.BLACK};

  ${MediaQuery.S_AND_DOWN} {
    font-size: ${FontSize.XXL};
  }
`;

const TypoXxxxl = css`
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.XXXXL};

  ${MediaQuery.S_AND_DOWN} {
    font-size: ${FontSize.XXL};
  }
`;

const TypoXxxlBolder = css`
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.XXXL};
  font-weight: ${FontWeight.BLACK};

  ${MediaQuery.S_AND_DOWN} {
    font-size: ${FontSize.XXL};
  }
`;

const TypoXxxl = css`
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.XXXL};

  ${MediaQuery.S_AND_DOWN} {
    font-size: ${FontSize.XXL};
  }
`;

const TypoXxlBolder = css`
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.XXL};
  font-weight: ${FontWeight.BLACK};

  ${MediaQuery.S_AND_DOWN} {
    font-size: ${FontSize.XL};
  }
`;

const TypoXxl = css`
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.XXL};

  ${MediaQuery.S_AND_DOWN} {
    font-size: ${FontSize.XL};
  }
`;

const TypoXlBolder = css`
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.XL};
  font-weight: ${FontWeight.BLACK};
`;

const TypoLBolder = css`
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.L};
  font-weight: ${FontWeight.BLACK};

  ${MediaQuery.S_AND_DOWN} {
    font-size: ${FontSize.M};
  }
`;

const TypoL = css`
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.L};

  ${MediaQuery.S_AND_DOWN} {
    font-size: ${FontSize.M};
  }
`;

const TypoM = css`
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.M};

  ${MediaQuery.S_AND_DOWN} {
    font-size: ${FontSize.S};
    font-weight: ${FontWeight.THIN};
  }
`;

const TypoMThinner = css`
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.M};
  font-weight: ${FontWeight.THIN};
`;

const TypoMBolder = css`
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.M};
  font-weight: ${FontWeight.BLACK};
`;

const TypoSBolder = css`
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.S};
  font-weight: ${FontWeight.BLACK};
`;

const TypoSThinner = css`
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.S};
  font-weight: ${FontWeight.THIN};
`;

const TypoXsBolder = css`
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.XS};
  font-weight: ${FontWeight.BLACK};
`;

const TypoXs = css`
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.XS};
`;

const TypoXsThinner = css`
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.XS};
  font-weight: ${FontWeight.THIN};
`;

const TypoXxsBolder = css`
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.XXS};
  font-weight: ${FontWeight.BLACK};
`;

const TypoXxs = css`
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.XXS};
`;

const TypoXxxs = css`
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.XXXS};
`;

export const Typography = {
  HUGE_BOLDER: TypoHugeBolder, // 60px
  XXXXXL_BOLDER: TypoXxxxxlBolder, // 42px
  XXXXL_BOLDER: TypoXxxxlBolder, // 36px
  XXXXL: TypoXxxxl,
  XXXL_BOLDER: TypoXxxlBolder, // 28px
  XXXL: TypoXxxl,
  XXL_BOLDER: TypoXxlBolder,
  XXL: TypoXxl, // 24px
  XL_BOLDER: TypoXlBolder, // 21px
  L_BOLDER: TypoLBolder,
  L: TypoL, // 18px
  M_BOLDER: TypoMBolder,
  M: TypoM, // 16px
  M_THINNER: TypoMThinner,
  S_BOLDER: TypoSBolder, //14px
  S_THINNER: TypoSThinner,
  XS_BOLDER: TypoXsBolder,
  XS: TypoXs, // 12px
  XS_THINNER: TypoXsThinner,
  XXS_BOLDER: TypoXxsBolder,
  XXS: TypoXxs, // 10px
  XXXS: TypoXxxs, // 8px
};
